import {ButtonProps} from '@mui/material/Button';
import React from 'react';
import {Button, useTheme} from '@mui/material';
import {css} from '@emotion/react'

export function ErrorButton(props: ButtonProps) {
	const theme = useTheme()
	const cssRoot = css`
		background-color: ${theme.palette.error.main};
		color: ${theme.palette.getContrastText(theme.palette.error.main)};

		&:hover {
			background-color: ${theme.palette.error.dark};
		}
	`
	return <Button {...props} css={cssRoot} className={props.className}/>
}